export class FinishContentDto {
    contentParticipantId: number;
    ratings: number[];
    ratingTexts: string[];
    doneDuringOfficeHours: boolean;
}
